import { Lock, UserFriends } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'
import { useShare } from './useShare'

export const Share: React.FC = () => {
  const {
    hasNotAvailableAccess,
    hasPassword,
    projectIsOnlyForMembers,
    onShareClick,
  } = useShare()

  return (
    <button
      className={css.share_btn}
      disabled={hasNotAvailableAccess}
      onClick={onShareClick}
    >
      Share
      {projectIsOnlyForMembers && <UserFriends />}
      {hasPassword && <Lock />}
    </button>
  )
}
